import React from 'react'
import t from '../helpers/i18n'

const NotFoundView = () => {
  return <div>{t('Page not found')}</div>
}

export default NotFoundView
